import React, { useEffect, useState, useRef } from "react";

const roles = [
  "Senior Software Engineer",
  "Full-Stack Developer",
  "Azure DevOps Specialist",
  "React & Next.js Expert",
  "Cloud Integration Engineer",
];

export default function HeroPage() {
  const [roleIndex, setRoleIndex] = useState(0);
  const [displayed, setDisplayed] = useState("");
  const [typing, setTyping] = useState(true);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const role = roles[roleIndex];
    if (typing) {
      if (displayed.length < role.length) {
        // Slower typing speed (100ms instead of 65ms) to reduce updates
        timeoutRef.current = setTimeout(() => setDisplayed(role.slice(0, displayed.length + 1)), 100);
      } else {
        timeoutRef.current = setTimeout(() => setTyping(false), 1800);
      }
    } else {
      if (displayed.length > 0) {
        // Slower deleting speed (60ms instead of 38ms) to reduce updates
        timeoutRef.current = setTimeout(() => setDisplayed(displayed.slice(0, -1)), 60);
      } else {
        setRoleIndex((i) => (i + 1) % roles.length);
        setTyping(true);
      }
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [displayed, typing, roleIndex]);

  return (
    <div style={{
      width: "100%", height: "100%",
      background: "linear-gradient(160deg,#060d1f 0%,#0d1627 55%,#0a1020 100%)",
      display: "flex", flexDirection: "column", alignItems: "center",
      justifyContent: "flex-start",
      fontFamily: "'Outfit','DM Sans',sans-serif",
      color: "white", padding: "18px 20px 12px",
      overflow: "hidden", position: "relative",
    }}>

      {/* BG glow */}
      <div style={{
        position: "absolute", top: "8%", left: "50%", transform: "translateX(-50%)",
        width: 260, height: 180,
        background: "radial-gradient(ellipse,rgba(99,102,241,0.12) 0%,transparent 70%)",
        pointerEvents: "none",
      }} />

      {/* Avatar + name row */}
      <div style={{ display: "flex", alignItems: "center", gap: 13, marginBottom: 10, zIndex: 1 }}>
        <div style={{
          width: 64, height: 64, borderRadius: "50%", flexShrink: 0,
          background: "linear-gradient(135deg,#6366f1,#06b6d4)",
          display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 0 20px rgba(99,102,241,0.5)",
          border: "2px solid rgba(99,102,241,0.4)",
          overflow: "hidden",
        }}>
          <img src="/MoezGRAMI.webp" alt="Moez Grami" style={{ width:"100%", height:"100%", objectFit:"cover" }} />
        </div>
        <div>
          <h1 style={{
            margin: "0 0 3px", fontSize: 32, fontWeight: 800, letterSpacing: 2,
            textTransform: "uppercase",
            background: "linear-gradient(90deg,#fff,#a5b4fc)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>Moez Grami</h1>
          <div style={{ fontSize: 17, color: "#06b6d4", letterSpacing: 1.5, fontWeight: 700, minHeight: 22 }}>
            {displayed}<span style={{ opacity: 0.5, animation: "blink 1s step-end infinite" }}>|</span>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div style={{ width: "82%", height: 1, background: "linear-gradient(90deg,transparent,rgba(99,102,241,0.5),transparent)", marginBottom: 10 }} />

      {/* Stats */}
      <div style={{ display: "flex", gap: 8, marginBottom: 10, zIndex: 1 }}>
        {[["6+","Years Exp."],["20+","Projects"],["5+","Companies"]].map(([n,l]) => (
          <div key={l} style={{
            textAlign: "center",
            background: "rgba(99,102,241,0.1)", border: "1px solid rgba(99,102,241,0.22)",
            borderRadius: 8, padding: "5px 9px",
          }}>
            <div style={{ fontSize: 24, fontWeight: 800, color: "#a5b4fc" }}>{n}</div>
            <div style={{ fontSize: 18, color: "#64748b", letterSpacing: 0.8 }}>{l}</div>
          </div>
        ))}
      </div>

      {/* Summary box */}
      <div style={{
        width: "100%", zIndex: 1,
        background: "rgba(99,102,241,0.07)", border: "1px solid rgba(99,102,241,0.18)",
        borderRadius: 10, padding: "9px 11px", marginBottom: 10,
      }}>
        <div style={{ fontSize: 18, fontWeight: 800, color: "#6366f1", letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 5 }}>
          Professional Summary
        </div>
        <p style={{ margin: 0, fontSize: 17, lineHeight: 1.65, color: "#94a3b8" }}>
          Senior Software Engineer with{" "}
          <span style={{ color: "#a5b4fc", fontWeight: 700 }}>6+ years</span> of experience in full-stack
          development, application support, deployment coordination, cloud integration, and production
          troubleshooting. Experienced in{" "}
          <span style={{ color: "#67e8f9", fontWeight: 600 }}>Azure DevOps</span>,{" "}
          <span style={{ color: "#67e8f9", fontWeight: 600 }}>REST APIs</span>, monitoring, and
          cross-functional collaboration within{" "}
          <span style={{ color: "#6ee7b7", fontWeight: 600 }}>Agile/Scrum</span> environments. Skilled
          in root cause analysis, deployment validation, and maintaining scalable enterprise applications.
        </p>
      </div>

      {/* Tech pills */}
      {/* <div style={{ display: "flex", gap: 4, flexWrap: "wrap", justifyContent: "center", zIndex: 1 }}>
        {["React","Next.js","TypeScript","Azure","Node.js","Vue","Docker"].map(t => (
          <span key={t} style={{
            fontSize: 12, padding: "3px 8px", borderRadius: 20,
            background: "rgba(6,182,212,0.08)", border: "1px solid rgba(6,182,212,0.28)",
            color: "#67e8f9", fontWeight: 600,
          }}>{t}</span>
        ))}
      </div> */}

      <div style={{ marginTop: 1, fontSize: 13, color: "#334155", zIndex: 1 }}>
        📍 Business Bay, Dubai, UAE
      </div>

      <style>{`@keyframes blink{0%,100%{opacity:1}50%{opacity:0}}`}</style>
    </div>
  );
}
